import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, Typography, Divider } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Logout from '@mui/icons-material/Logout';
import Settings from '@mui/icons-material/Settings';
import AdminPanelSettings from '@mui/icons-material/AdminPanelSettings';
import SecurityIcon from '@mui/icons-material/Security';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const UserMenu: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // Check if user is admin
  const isAdmin = user?.is_staff || user?.is_superuser;

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleClose();
    await logout();
    // Redirect to landing page after logout
    window.location.href = '/';
  };

  return (
    <>
      <IconButton
        size="large"
        edge="end"
        color="inherit"
        onClick={handleMenu}
        aria-label="user menu"
        data-testid="user-menu-button"
      >
        <AccountCircle />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        data-testid="user-menu"
      >
        <Typography variant="subtitle1" sx={{ px: 2, pt: 1, pb: 0.5 }}>
          {user?.first_name || user?.username || 'User'}
        </Typography>
        <Divider />
        <MenuItem onClick={() => { handleClose(); navigate('/settings'); }}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Profile / Settings
        </MenuItem>
        <MenuItem onClick={() => { handleClose(); navigate('/my-data'); }}>
          <ListItemIcon>
            <SecurityIcon fontSize="small" />
          </ListItemIcon>
          My Data & Privacy
        </MenuItem>
        {isAdmin && (
          <MenuItem onClick={() => { handleClose(); navigate('/admin/companies'); }}>
            <ListItemIcon>
              <AdminPanelSettings fontSize="small" />
            </ListItemIcon>
            Company Management
          </MenuItem>
        )}
        <Divider />
        <MenuItem onClick={handleLogout} data-testid="logout-button">
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserMenu; 